var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIdCard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 68.436,
    height: 49.581,
    viewBox: "0 0 68.436 49.581",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8.505)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.505)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.26,55.086H5.176A5.053,5.053,0,0,1,0,50.179V10.413A5.053,5.053,0,0,1,5.176,5.505H63.26a5.053,5.053,0,0,1,5.176,4.908V50.181A5.051,5.051,0,0,1,63.26,55.086ZM5.176,7.468A3.032,3.032,0,0,0,2.07,10.413V50.181a3.032,3.032,0,0,0,3.106,2.945H63.26a3.032,3.032,0,0,0,3.106-2.945V10.413A3.032,3.032,0,0,0,63.26,7.468Z",
    transform: "translate(0 -5.505)",
    fill: "#3d5567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.042,7.468H8.472a.983.983,0,1,1,0-1.963H44.044a.983.983,0,1,1,0,1.963Z",
    transform: "translate(7.961 -5.505)",
    fill: "#3d5567"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.219,39.839H5.862a1.01,1.01,0,0,1-1.035-.982V36.231A4.269,4.269,0,0,1,7.4,32.379l5.482-3.2a7.427,7.427,0,0,1-2.959-5.568l-.209-5.175a7.378,7.378,0,0,1,7.6-7.142h1.445a7.376,7.376,0,0,1,7.6,7.1l-.211,5.212a7.412,7.412,0,0,1-2.965,5.571l5.54,3.216a4.269,4.269,0,0,1,2.524,3.83v2.625A1,1,0,0,1,30.219,39.839ZM6.9,37.876H29.183V36.233a2.3,2.3,0,0,0-1.391-2.079.91.91,0,0,1-.1-.051l-6.988-4.056a.969.969,0,0,1-.495-.879.986.986,0,0,1,.571-.836,5.6,5.6,0,0,0,3.3-4.792l.211-5.175a5.347,5.347,0,0,0-5.532-5.1H17.318a5.352,5.352,0,0,0-5.53,5.141L12,23.539a5.6,5.6,0,0,0,3.29,4.788.958.958,0,0,1,.077,1.714L8.386,34.1A2.366,2.366,0,0,0,6.9,36.229v1.647Z",
    transform: "translate(5.167 0.076)",
    fill: "#3d5567"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.729 15.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.945,15.59H22.156a.983.983,0,1,1,0-1.963H34.945a.983.983,0,1,1,0,1.963Z",
    transform: "translate(-21.121 -13.627)",
    fill: "#3d5567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.945,20.029H22.156a.983.983,0,1,1,0-1.963H34.945a.983.983,0,1,1,0,1.963Z",
    transform: "translate(-21.121 -9.352)",
    fill: "#3d5567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.945,24.471H22.156a.983.983,0,1,1,0-1.963H34.945a.983.983,0,1,1,0,1.963Z",
    transform: "translate(-21.121 -5.073)",
    fill: "#3d5567"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIdCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/id-card.40c7349c.svg";
export { ForwardRef as ReactComponent };